import React from 'react';

// Compact KPI tile for the admin2 dashboard stat rows. Same rounded-2xl white
// surface as Card, with a coloured icon chip, a large value and a small label.
// `tone` picks the icon-chip palette; defaults to the admin2 purple accent.
const TONES = {
    purple: { bg: '#EFEAFE', fg: '#5B3FE0' },
    green: { bg: '#E7F7EF', fg: '#12855A' },
    blue: { bg: '#E8F1FE', fg: '#1D5FD6' },
    amber: { bg: '#FDF1DF', fg: '#B7791F' },
};

// Small week-on-week delta pill. Positive is treated as good (green), negative
// as a pull-back (grey); zero renders nothing so the tile stays calm.
const DeltaPill = ({ delta }) => {
    if (delta == null || delta === 0) return null;
    const up = delta > 0;
    return (
        <span
            className="inline-flex items-center gap-0.5 rounded-full px-1.5 py-0.5 text-[11px] font-bold leading-none"
            style={
                up
                    ? { backgroundColor: '#E7F7EF', color: '#12855A' }
                    : { backgroundColor: '#F3F4F6', color: '#6B7280' }
            }
            title="vs the previous 7 days"
        >
            {up ? '↑' : '↓'}
            {Math.abs(delta)}
        </span>
    );
};

const StatCard = ({ icon, value, label, hint, tone = 'purple', delta }) => {
    const palette = TONES[tone] || TONES.purple;
    return (
        <div className="rounded-2xl bg-white shadow-sm border border-[#E5E7EB] p-4 sm:p-5 flex items-center gap-4">
            {icon ? (
                <span
                    className="inline-flex items-center justify-center h-11 w-11 rounded-xl flex-shrink-0"
                    style={{ backgroundColor: palette.bg, color: palette.fg }}
                >
                    {icon}
                </span>
            ) : null}
            <div className="min-w-0">
                <div className="flex items-center gap-2">
                    <p className="text-2xl font-bold text-[#1F2937] leading-none">{value}</p>
                    <DeltaPill delta={delta} />
                </div>
                <p className="text-xs font-semibold text-[#6B7280] mt-1.5 truncate">{label}</p>
                {hint ? <p className="text-[11px] text-[#9CA3AF] mt-0.5 truncate">{hint}</p> : null}
            </div>
        </div>
    );
};

export default StatCard;
